var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { PartnerBadgeEnum } from "@/types";
import { Box } from "@gemini/core";
import { DiamondPartner } from "./PartnerBadgeTags/DiamondPartner";
import { PlatinPartner } from "./PartnerBadgeTags/PlatinPartner";
import { BusinessPartner } from "./PartnerBadgeTags/BusinessPartner";
import { PremiumPartner } from "./PartnerBadgeTags/PremiumPartner";
import { SimplePartner } from "./PartnerBadgeTags/SimplePartner";
import { PartnerBadgesModal } from "../PartnerBadgesModal";
import { useProviderSection } from "@/contexts/contact";
const badgeComponents = {
    [PartnerBadgeEnum.diamond]: DiamondPartner,
    [PartnerBadgeEnum.business]: BusinessPartner,
    [PartnerBadgeEnum.platin]: PlatinPartner,
    [PartnerBadgeEnum.simple]: SimplePartner,
    [PartnerBadgeEnum.premium]: PremiumPartner,
};
export const StandaloneBadges = ({ rootTestId, marginBottom = "spacing.16", marginTop = "spacing.8", }) => {
    var _a;
    const { badges } = (_a = useProviderSection()) !== null && _a !== void 0 ? _a : {};
    if (!(badges === null || badges === void 0 ? void 0 : badges.length))
        return null;
    return (_jsx(Box, { display: "flex", flexWrap: "wrap", gap: "spacing.8", marginTop: marginTop, marginBottom: marginBottom, children: badges === null || badges === void 0 ? void 0 : badges.map((badge) => {
            const BadgeComponent = badgeComponents[badge.title];
            if (!BadgeComponent)
                return null;
            const TriggerWrapper = (_a) => {
                var { onPress } = _a, rest = __rest(_a, ["onPress"]);
                return (_jsx(Box, Object.assign({ as: "button", margin: "spacing.none", padding: "spacing.none", borderWidth: "borderWidth.none", cursor: "pointer", onClick: onPress }, rest, { "aria-haspopup": "dialog", "aria-expanded": undefined, "aria-label": badge.title, children: _jsx(BadgeComponent, {}) })));
            };
            return (_jsx(Box, { testId: rootTestId, children: _jsx(PartnerBadgesModal, { badges: badges, customTrigger: TriggerWrapper }) }, badge.title));
        }) }));
};
